import React from "react";
import { Select } from "antd";
import { Button, Switch } from "../../../BP2Components";
import IntlMessages from "../../../../util/IntlMessages";
import { filterColumns } from "../../WidgetsSettings/KanbanSettings/KanbanSettings";
import { KanbanScripts } from "./KanbanScripts";

const { validColumnsForHorizontalPlacement } = KanbanScripts;

const { Option } = Select;

const KanbanViewSettings = ({
   viewSettings,
   setViewSettings,
   columns,
   rows,
   settings,
   fetchedProfiles,
   selectProfil,
   initialProfile
}) => {
   const handleChange = (value, parameter) => {
      setViewSettings({ ...viewSettings, [parameter]: value });
   };

   return (
      <div className="container-for-settings">
         {settings.showSortColumns && (
            <div className="settings-sortColumns sort-container">
               <span className="switch-text">
                  <IntlMessages id="kanban.column" />:
               </span>
               <Select
                  value={viewSettings.sortColumnsBy}
                  className="kanban-select-sort"
                  onChange={(e) => handleChange(e, "sortColumnsBy")}
               >
                  {validColumnsForHorizontalPlacement(columns).map(({ title, techName }, i) => (
                     <Option value={techName} key={i}>
                        {title}
                     </Option>
                  ))}
               </Select>
               <Button
                  buttonType="default"
                  className="kanban-button-arrow_sort"
                  onClick={(e) => handleChange(!viewSettings.sortColumns, "sortColumns")}
               >
                  {viewSettings.sortColumns ? ">" : "<"}
               </Button>
            </div>
         )}
         {settings.showSortRows && (
            <div className="settings-sortRows sort-container">
               <span className="switch-text">
                  <IntlMessages id="kanban.row" />:
               </span>
               <Select
                  value={viewSettings.sortRowsBy}
                  onChange={(e) => handleChange(e, "sortRowsBy")}
               >
                  {filterColumns(columns, rows).map(({ title, techName }, i) => (
                     <Option value={techName} key={i}>
                        {title}
                     </Option>
                  ))}
               </Select>
               <Button
                  buttonType="default"
                  className="kanban-button-arrow_sort"
                  onClick={(e) => handleChange(!viewSettings.sortRows, "sortRows")}
               >
                  {viewSettings.sortRows ? "v" : "^"}
               </Button>
            </div>
         )}
         <div className="settings-blockValueOnMove">
            <span className="switch-text">
               <IntlMessages id="kanban.changeValuesOfFieldsByMovingObjects" />
            </span>
            <Switch
               defaultChecked={true}
               className="kanban-switch-blockValueOnMove"
               onChange={(e) => handleChange(e, "enableEditByMovingElements")}
            ></Switch>
         </div>
         {fetchedProfiles === false ? null : (
            <div className="profile-select-container">
               <div className="profile-text">
                  <IntlMessages id="kanban.profileSelect" />:
               </div>
               <Select
                  className="profile-select"
                  onChange={(e) => selectProfil(e)}
                  defaultValue={
                     fetchedProfiles?.find((profile) => profile?.id === initialProfile)?.name
                  }
               >
                  {fetchedProfiles?.map((profile) => (
                     <Option value={profile?.id} key={profile?.id}>
                        {profile?.name}
                     </Option>
                  ))}
               </Select>
            </div>
         )}
      </div>
   );
};

export default KanbanViewSettings;
